
import Base from './base'

export default {
  name: 'VsTableExpand',
  extends: Base,
  vessel: {
    button: {
      cursor: 'pointer'
    }
  },
  watch: {
    total() {
      this.expanded = this.table.expanded.has(this.row)
    }
  },
  data() {
    return {
      expanded: false
    }
  },
  computed: {
    total() {
      return this.table.expandedSize
    },
    icon() {
      return this.expanded ? 'angle-down' : 'angle-right'
    }
  },
  methods: {
    onClick() {
      this.table.toggleRowExpansion(this.row, !this.expanded)
    }
  },
  mounted() {
    if (this.$refs.expand) {
      this.$row.parentNode.insertBefore(
        this.$refs.expand, this.$row.nextSibling
      )
    }
  },
  destroyed() {
    if (this.$refs.expand) {
      this.$row.parentNode.removeChild(this.$refs.expand)
    }
  }
}
